import React, { useState, FormEvent } from 'react'
import { register } from '../api/api'

interface FormData {
	firstName: string
	lastName: string
	username: string
	email: string
	password: string
	password2: string
	dob: string
	reference: string
	rules: boolean
}

const Register: React.FC = () => {
	const [formData, setFormData] = useState<FormData>({
		firstName: '',
		lastName: '',
		username: '',
		email: '',
		password: '',
		password2: '',
		dob: '',
		reference: '',
		rules: false,
	})

	const [error, setError] = useState<string | null>(null)

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value, type, checked } = e.target
		setFormData(prev => ({
			...prev,
			[name]: type === 'checkbox' ? checked : value,
		}))
	}

	const handleSubmit = async (e: FormEvent) => {
		e.preventDefault()
		setError(null)

		// Простая валидация
		if (formData.password !== formData.password2) {
			setError('Passwords do not match')
			return
		}

		if (!formData.rules) {
			setError('You must agree to the terms and conditions')
			return
		}

		// Здесь можно отправить данные на сервер
		console.log('Form submitted:', formData)
		try {
			await register(formData)
			alert('Registration successful!')
		} catch (err) {
			setError('Registration failed. Please try again.')
		}
		// Например, вызов API:
		// await registerUser(formData);
	}

	return (
		<>
			<h2 className='text-3xl font-bold text-sky-600 text-center p-10'>
				Registration
			</h2>
			{error && <div className='text-red-500 mb-4 text-center'>{error}</div>}
			<form id='registration_form' onSubmit={handleSubmit}>
				<div className='grid grid-cols-2 gap-4 mb-3'>
					{/* First Name */}
					<div className='mb-3'>
						<label htmlFor='first_name' className='block text-sky-800'>
							First Name
						</label>
						<input
							type='text'
							name='firstName'
							id='first_name'
							value={formData.firstName}
							onChange={handleChange}
							className='block w-full p-4 bg-sky-200 border-2 border-sky-500 text-sky-800 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
							required
						/>
					</div>

					{/* Last Name */}
					<div className='mb-3'>
						<label htmlFor='last_name' className='block text-sky-800'>
							Last Name
						</label>
						<input
							type='text'
							name='lastName'
							id='last_name'
							value={formData.lastName}
							onChange={handleChange}
							className='block w-full p-4 bg-sky-200 border-2 border-sky-500 text-sky-800 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
							required
						/>
					</div>
				</div>

				{/* Username */}
				<div className='mb-3'>
					<label htmlFor='username' className='block text-sky-800'>
						Username
					</label>
					<input
						type='text'
						name='username'
						id='username'
						value={formData.username}
						onChange={handleChange}
						className='block w-full p-4 bg-sky-200 border-2 border-sky-500 text-sky-800 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
						required
					/>
				</div>

				{/* Email */}
				<div className='mb-3'>
					<label htmlFor='email' className='block text-sky-800'>
						Email
					</label>
					<input
						type='email'
						name='email'
						id='email'
						value={formData.email}
						onChange={handleChange}
						className='block w-full p-4 bg-sky-200 border-2 border-sky-500 text-sky-800 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
						required
					/>
				</div>

				{/* Password */}
				<div className='mb-3'>
					<label htmlFor='password' className='block text-sky-800'>
						Password
					</label>
					<input
						type='password'
						name='password'
						id='password'
						value={formData.password}
						onChange={handleChange}
						className='block w-full p-4 bg-sky-200 border-2 border-sky-500 text-sky-800 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
						required
					/>
				</div>

				{/* Confirm Password */}
				<div className='mb-3'>
					<label htmlFor='password_2' className='block text-sky-800'>
						Confirm your password
					</label>
					<input
						type='password'
						name='password2'
						id='password_2'
						value={formData.password2}
						onChange={handleChange}
						className='block w-full p-4 bg-sky-200 border-2 border-sky-500 text-sky-800 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
						required
					/>
				</div>

				{/* Date of Birth */}
				<div className='relative mb-3'>
					<label htmlFor='dob' className='block text-sky-800'>
						Date of Birth
					</label>
					<input
						type='date'
						name='dob'
						id='dob'
						value={formData.dob}
						onChange={handleChange}
						className='block w-full p-4 bg-sky-200 border-2 border-sky-500 text-sky-800 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 [&::-webkit-calendar-picker-indicator]:text-blue-500 [&::-webkit-calendar-picker-indicator]:hover:text-blue-700'
						required
					/>
				</div>

				{/* Reference (скрытое поле) */}
				<div className='mb-3 hidden'>
					<label htmlFor='reference' className='block text-sky-800'>
						Reference
					</label>
					<input
						type='text'
						name='reference'
						id='reference'
						value={formData.reference}
						onChange={handleChange}
						className='block w-full p-4 text-primary border border-gray-900 rounded-lg bg-red-950 text-base focus:ring-blue-500 focus:border-red-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
					/>
				</div>

				{/* Checkbox */}
				<div className='mb-3 text-center flex items-center justify-center space-x-2'>
					<input
						type='checkbox'
						name='rules'
						id='rules'
						checked={formData.rules}
						onChange={handleChange}
						className='w-4 h-4 text-blue-600 bg-gray-100 border-gray-900 rounded focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600'
						required
					/>
					<label htmlFor='rules' className='text-sky-800'>
						I agree to the terms and conditions
					</label>
				</div>

				{/* Submit Button */}
				<div className='mb-3 text-center'>
					<button
						type='submit'
						className='p-4 bg-sky-600 hover:bg-sky-700 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 mx-auto'
					>
						Register
					</button>
				</div>
			</form>
		</>
	)
}

export default Register
